import { useCallback, useRef } from 'react';

// IntersectionObserver sentinel → onLoadMore at ~80% (parity BaseListScreen.kt:89-103).
export function useInfiniteScroll(opts: { onLoadMore: () => void; disabled?: boolean }) {
  const observer = useRef<IntersectionObserver | null>(null);
  const { onLoadMore, disabled } = opts;
  return useCallback(
    (node: HTMLElement | null) => {
      observer.current?.disconnect();
      if (!node || disabled) return;
      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0]?.isIntersecting) onLoadMore();
        },
        { rootMargin: '0px 0px 20% 0px' }, // fire before fully in view (~80% parity)
      );
      observer.current.observe(node);
    },
    [onLoadMore, disabled],
  );
}
